export interface ElectricWhereClauseOptions {
  quoteColumn?: boolean;
}

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const normalizeElectricUrl = (value?: string | null): string =>
  value?.replace("wss://", "https://") ?? "";

export const isValidElectricUuid = (value: string): boolean => UUID_RE.test(value);

export const buildElectricWhereClause = (
  column: string,
  uuid: string,
  options?: ElectricWhereClauseOptions
): string | undefined => {
  if (!uuid || !isValidElectricUuid(uuid)) return undefined;
  const safeColumn = options?.quoteColumn ? `"${column}"` : column;
  return `${safeColumn} = '${uuid}'`;
};

export const isElectricConnectionConfigured = (electricUrl: string): boolean =>
  typeof electricUrl === "string" && electricUrl.length > 0;
